// extracted by mini-css-extract-plugin
module.exports =  {"container":"YmCwRYC2LvIiy6iF6b5p"};